import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ru from './ru.json';

/**
 * Russian-only for now (SPEC §5), but every UI string goes through a key so
 * adding a language later is a json file, not a refactor.
 */
void i18n.use(initReactI18next).init({
  resources: { ru: { translation: ru } },
  lng: 'ru',
  fallbackLng: 'ru',
  interpolation: { escapeValue: false },
  returnEmptyString: false,
});

export default i18n;
